'use client';

import { useCallback } from 'react';
import { 
  capture, 
  identify, 
  reset, 
  isFeatureEnabled, 
  getFeatureFlag, 
  group, 
  setPersonProperties,
  alias,
} from '@/lib/posthog';

export function usePostHog() {
  // Event tracking
  const track = useCallback((eventName: string, properties?: Record<string, unknown>) => {
    capture(eventName, properties);
  }, []);

  // User identification
  const identifyUser = useCallback((userId: string, properties?: Record<string, unknown>) => {
    identify(userId, properties);
  }, []);

  // Reset user session
  const resetUser = useCallback(() => {
    reset();
  }, []);

  // Feature flags
  const isFeatureFlag = useCallback((flagKey: string): boolean => {
    return isFeatureEnabled(flagKey);
  }, []);

  const getFlag = useCallback((flagKey: string) => {
    return getFeatureFlag(flagKey);
  }, []);

  // Group tracking
  const identifyGroup = useCallback((groupType: string, groupKey: string, properties?: Record<string, unknown>) => {
    group(groupType, groupKey, properties);
  }, []);

  // Set user properties
  const setUserProperties = useCallback((properties: Record<string, unknown>) => {
    setPersonProperties(properties);
  }, []);

  // Alias user
  const aliasUser = useCallback((aliasId: string) => {
    alias(aliasId);
  }, []);

  return {
    track,
    identifyUser,
    resetUser,
    isFeatureFlag,
    getFlag,
    identifyGroup,
    setUserProperties,
    aliasUser,
  };
} 